import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { useEngagementPermissions } from '@anytag/auth';
import { ConfirmDeleteModal } from '@anytag/shared-molecules';
import { useQueryHelper, useSelectItem } from '@anytag/shared-hooks';
import { Engagement, namedOperations, useDeleteEngagementMutation } from '@anytag/graphql';
import { useEngagementCampaignsTable } from './hooks';

export type EngagementCampaignsListProps = TableData<Engagement>;

export const EngagementCampaignsList = ({ loading, data = [] }: EngagementCampaignsListProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { hideAddEngagementBtn } = useEngagementPermissions();
  const { selectedItem, setSelectedItem, resetSelectedItem } = useSelectItem();
  const { columns } = useEngagementCampaignsTable({ onDeleteEngagement: setSelectedItem });
  const { callDeleteEngagement, loading: deleting } = useDeleteEngagementMutation({
    refetchQueries: [namedOperations.Query.AllEngagements]
  });

  const handleDeleteEngagement = async () => {
    if (!selectedItem) {
      return;
    }

    try {
      await callDeleteEngagement({ variables: { id: selectedItem.id } });
      enqueueSnackbar(t('succeededInDeleting', { name: selectedItem.name }), { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(t('failedToDelete', { name: selectedItem.name }), { variant: 'error' });
    } finally {
      resetSelectedItem();
    }
  };

  return (
    <>
      <TableV2
        data={data}
        columns={columns}
        loading={loading}
        empty={{
          linkProps: !hideAddEngagementBtn ? { to: '/engagement/add', label: t('General.add a campaign') } : undefined
        }}
        hasBorder
        noTopBorderRadius
      />

      <ConfirmDeleteModal
        deleting={deleting}
        onClose={resetSelectedItem}
        deletingItem={selectedItem}
        onDelete={handleDeleteEngagement}
      />
    </>
  );
};
